import React, { Component } from 'react';

import { Alert, Spinner } from 'reactstrap';

import Conteudo from './Conteudo';

export default class extends Component {
  render() {
    return (<Conteudo>
      <Alert fade={false} color="dark"><Spinner size="sm" color="dark" /> Verificando permissões...</Alert>
    </Conteudo>);
  }
}



// WEBPACK FOOTER //
// ./src/Loading.js